



















































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import Ajax from "../../lib/ajax";
import CreateSupplier from "./create-supplier.vue";
import EditSupplier from "./edit-supplier.vue";
class PagesupplierRequest extends PageRequest {
  name: string;
  supplierType:number;
}

@Component({
  components: { EditSupplier, CreateSupplier },
})
export default class suppliers extends AbpBase {
  // 编辑按钮事件处理
  edit() {
    this.editModalShow = true;
  }
  //请求过滤参数
  pagerequest: PagesupplierRequest = new PagesupplierRequest();
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  supplierId: number = null;
  supplierTypeList:Array<object>=[{
    label:'付款方',
    value:0
  },{
    label:'收款方',
    value:1
  }]

  get list() {
    return this.$store.state.supplier.list;
  }
  get loading() {
    return this.$store.state.supplier.loading;
  }
  create() {
    this.createModalShow = true;
  }

  pageChange(page: number) {
    this.$store.commit("supplier/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("supplier/setPageSize", pagesize);
    this.getpage();
  }
  search() {
    this.$store.commit("supplier/setCurrentPage", 1);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "supplier/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.supplier.pageSize;
  }
  get totalCount() {
    return this.$store.state.supplier.totalCount;
  }
  get currentPage() {
    return this.$store.state.supplier.currentPage;
  }

  columns = [
    {
      title: "名称",
      key: "name",
    },
    {
      title: "手机号",
      key: "phoneNumber",
    },
    {
      title: "供应商类型",
      key: "supplierType",
      render: (h: any, params: any) => {
        return h("span", params.row.supplierType == 0 ? "付款方" : "收款方");
      },
    },
    {
      title: "供应商简介",
      key: "introduction",
      tooltip: true,
    },

    {
      title: "备注",
      key: "remark",
      tooltip: true,
    },
    {
      title: this.L("CreationTime"),
      key: "creationTime",
      render: (h: any, params: any) => {
        return h(
          "span",
          new Date(params.row.creationTime).toLocaleDateString()
        );
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 150,
      align: "center",
      slot: "action",
      render: (h: any, params: any) => {
        const hasEditPermission = this.hasPermission("Pages.Suppliers.Edit");
        const hasDeletePermission = this.hasPermission(
          "Pages.Suppliers.Delete"
        );
        const buttons = [];
        if (hasEditPermission) {
          buttons.push(
            h(
              "Button",
              {
                props: {
                  type: "primary",
                  size: "small",
                },
                style: {
                  marginRight: "5px",
                },
                on: {
                  click: () => {
                    this.supplierId = params.row.id;
                    this.$store.commit("supplier/edit", params.row);
                    this.edit();
                  },
                },
              },
              "编辑"
            )
          );
        }
        if (hasDeletePermission) {
          buttons.push(
            h(
              "Button",
              {
                props: {
                  type: "error",
                  size: "small",
                },
                on: {
                  click: async () => {
                    this.$Modal.confirm({
                      title: this.L("Tips"),
                      content: "确定要删除该供应商吗",
                      okText: this.L("Yes"),
                      cancelText: this.L("No"),
                      onOk: async () => {
                        await this.$store.dispatch({
                          type: "supplier/delete",
                          data: params.row,
                        });
                        await this.getpage();
                      },
                    });
                  },
                },
              },
              "删除"
            )
          );
        }
        return h("div", buttons);
      },
    },
  ];
  async created() {
    this.getpage();
  }
}
